import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6fee69e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "window main" }
const _hoisted_2 = { class: "title-bar" }
const _hoisted_3 = { class: "title-bar-text" }
const _hoisted_4 = { class: "title-bar-controls" }
const _hoisted_5 = { class: "window-body" }
const _hoisted_6 = { class: "code-holder" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-bar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "status-bar-field" }, "Ready")
], -1))

import { inject } from "vue";
import QRToken from "@/components/QRToken.vue";
import { Pages } from "@/Pages";
import { Config } from "@/config";


export default /*#__PURE__*/_defineComponent({
  __name: 'ParticipantPage',
  props: {
    token: {}
  },
  emits: ["navigate"],
  setup(__props: any, { emit }) {

const props = __props;



const config = inject<Config>("config") as Config;

const link =
  config.AppProtocol + "://android/token=" + encodeURIComponent(props.token);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(config).ServerName) + " User Token Generator ", 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          "aria-label": "Help",
          title: "Help",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('navigate', _unref(Pages).Help)))
        }),
        _createElementVNode("button", {
          "aria-label": "Close",
          title: "Close",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('navigate', _unref(Pages).Root)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", null, [
        _createTextVNode(" Your token is: "),
        _createElementVNode("code", null, _toDisplayString(props.token), 1)
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("a", { href: link }, "Click here to open the app and log in")
      ]),
      _createElementVNode("p", _hoisted_6, [
        _createVNode(QRToken, {
          token: props.token
        }, null, 8, ["token"])
      ])
    ]),
    _hoisted_7
  ]))
}
}

})